import { AppState } from '../reducers'
import { PAGINATION_STATE_KEY } from './constants'

export const getPaginationState = (state: AppState) => state[PAGINATION_STATE_KEY]
export const getPagination = (state: AppState, tableName: string) => getPaginationState(state).tables[tableName]
export const getCurrentPage = (state: AppState, tableName: string) =>
  getPaginationState(state).tables[tableName].currentPage
